import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvListValue,
    DetailPanel,
    DetailKvTable,
    KV_LIST_TYPES,
} from '../../../../components/detailLayout';
import React, {useEffect, useMemo, useState} from 'react';
import {getServiceApply, updateServiceApply} from "../../../../api/serviceRequest/ServiceApplyService";
import {useParams} from "react-router-dom";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import Th_title from "../../../../components/Th_title";
import {useDispatch, useSelector} from "react-redux";
import {
    resetContents,
    setApprovalProcesses,
    setCode,
    setSequencingCodeName
} from "../../../../redux/slice/contentSlice";
import ApprovalComponent from "../../../settings/approval/new/ApprovalComponent";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import {apiLoading, skeleton} from "../../../../redux/slice/apiSlice";
import ServiceRequestFeedback from "../../serviceRequest/subpage/ServiceRequestFeedback";
import SimmsInput from "../../../../components/input/SimmsInput";
import {inputOnChange, inputOnKeyDown} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import {TaskManager} from "../../../maintenance/shared/TaskManager";

const ServiceApplyInfo = () => {
    const [serviceApply, setServiceApply] = useState({});
    const {id} = useParams();

    const progressStatusValue = useSelector(state => state.content.progressStatusValue);
    const sequencingCodeName = useSelector(state => state.content.sequencingCodeName);
    const refreshContent = useSelector(state => state.status.refreshContent);
    const contentApproval = useSelector(state => state.content.contentApproval);

    const dispatch = useDispatch();

    const canEditRequest = (contentApproval) => {
        if (!contentApproval?.contentApprovalGroups?.length) {
            return false;
        }

        const actualApprovalGroups = contentApproval.contentApprovalGroups
            .filter(group => group.approvalType !== "HAS_NO_APPROVERS");

        const sortedActualGroups = actualApprovalGroups
            .sort((a, b) => a.orders - b.orders);

        return sortedActualGroups[0].approvalType === "PENDING";
    };

    useEffect(() => {
        if (!id) return;
        setServiceApply({});
        handleCallServiceApply();
        dispatch(skeleton(false));
        dispatch(resetContents());
        return () => dispatch(resetContents());
    }, [id, refreshContent]);

    const handleCallServiceApply = async () => {
        dispatch(apiLoading(true));
        const response = await getServiceApply(id);
        if (response && response.status === 200) {
            dispatch(apiLoading(false));
            const data = response.data;
            setServiceApply({...data});
            dispatch(setApprovalProcesses([{...data.approvalProcess}]));
            const codes = response.data.serviceCodes;
            if (codes && codes.length > 0) {
                const codeNames = codes.filter(code => code.parentId !== 0).map(code => code.name).join(" > ");
                const code = codes.pop();
                dispatch(setSequencingCodeName(codeNames));
                dispatch(setCode({...code}));
            }
        }
    }

    const editable = progressStatusValue.statusNumericValue === 10 && canEditRequest(contentApproval);

    const taskManagerData = useMemo(() => ({
        ...serviceApply,
        id: serviceApply.serviceRequestId ?? serviceApply.id,
        serviceRequestId: serviceApply.serviceRequestId,
    }), [serviceApply]);

    const handlerItems = useMemo(() => {
        if (Array.isArray(serviceApply.handlers) && serviceApply.handlers.length > 0) {
            return serviceApply.handlers;
        }
        if (serviceApply.inProgressCloseUser) {
            return [serviceApply.inProgressCloseUser];
        }
        return [];
    }, [serviceApply.handlers, serviceApply.inProgressCloseUser]);

    const requestInfoPanel = (
        <>
            <DetailPanel title={"기본정보"}>
                <DetailKvTable>
                    <tbody>
                    {editable ? (
                        <tr>
                            <Th_title title={"요청제목"} colspan={3} className="fieldset-td" auth>
                                <SimmsInput onChange={(v)=>inputOnChange(setServiceApply,"title", v, true)}
                                            update onKeyDown={(v, e)=>inputOnKeyDown(setServiceApply, updateServiceApply, serviceApply.id, "title", v, e, true)}
                                            data={serviceApply.title} />
                            </Th_title>
                        </tr>
                    ) : (
                        <tr>
                            <Th_title title={"요청제목"} className="fieldset-td" colspan={3}>
                                <ReadOnlyInputBasic value={serviceApply.title} />
                            </Th_title>
                        </tr>
                    )}

                    {editable ? (
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"요청내용"} colspan={3} className="fieldset-td" auth>
                                <SimmsTextArea onChange={(v)=>inputOnChange(setServiceApply,"description", v, false)}
                                               update onKeyDown={(v, e)=>inputOnKeyDown(setServiceApply, updateServiceApply, serviceApply.id, "description", v, e, false)}
                                               style={{minHeight:'80px'}}
                                               data={serviceApply.description} />
                            </Th_title>
                        </tr>
                    ) : (
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"요청내용"} className="fieldset-td" colspan={3}>
                                <div className={`align-text-div`}>{serviceApply.description}</div>
                            </Th_title>
                        </tr>
                    )}

                    <tr>
                        <Th_title title={"등록일자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"createdAt"}
                                data={{data: serviceApply, setData: setServiceApply}}
                                value={serviceApply.createdAt}
                            />
                        </Th_title>
                        <Th_title title={"수정일자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"updatedAt"}
                                data={{data: serviceApply, setData: setServiceApply}}
                                value={serviceApply.updatedAt}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"등록자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"createdBy"}
                                data={{data: serviceApply, setData: setServiceApply}}
                                value={serviceApply.createUser?.name}
                            />
                        </Th_title>
                        <Th_title title={"수정자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"updatedBy"}
                                data={{data: serviceApply, setData: setServiceApply}}
                                value={serviceApply.updateUser?.name}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청자"} className="fieldset-td" colspan={3}>
                            <ReadOnlyInputBasic
                                target={"applier"}
                                data={{data: serviceApply, setData: setServiceApply}}
                                value={serviceApply.applier?.name}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청마감일"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"requestCloseDate"}
                                data={{data: serviceApply, setData: setServiceApply}}
                                value={serviceApply.requestCloseDate}
                            />
                        </Th_title>
                        <Th_title title={"일련번호"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"contentSerial"}
                                data={{data: serviceApply, setData: setServiceApply}}
                                value={serviceApply.serialNumber}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청코드"} className="fieldset-td" colspan={3}>
                            <span>{sequencingCodeName}</span>
                        </Th_title>
                    </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        </>
    );

    const workflowPanels = (
        <>
            <ServiceRequestFeedback
                serviceRequest={serviceApply}
                initialData={{
                    id: serviceApply.serviceRequestId,
                    feedbackUserId: serviceApply.feedbackUserId,
                    feedbackRating: serviceApply.feedbackRating,
                    feedbackDescription: serviceApply.feedbackDescription,
                }}
            />
            <TaskManager
                data={taskManagerData}
                contentCategory={ContentCategory.SERVICE_REQUEST}
                verificationOnly
                statusRows={handlerItems.length > 0 ? (
                    <>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"처리담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue
                                    items={handlerItems}
                                    listType={KV_LIST_TYPES.user}
                                />
                            </Th_title>
                        </tr>
                    </>
                ) : null}
            />
            {(serviceApply.adjustedRequestCloseDate || progressStatusValue.rejected === ContentStatus.REJECT.statusValue) && (
                <DetailPanel title={"검토관리"}>
                    <DetailKvTable>
                        <tbody>
                        {serviceApply.adjustedRequestCloseDate && (
                            <tr>
                                <Th_title title={"조정정보"} className="fieldset-td" colspan={3}>
                                    <div className={`px-[12px] py-2`}>{`요청 마감 조정일 : ${serviceApply.adjustedRequestCloseDate}`}</div>
                                    <div className={"mt-2 align-text-div"}>{serviceApply.adjustDescription}</div>
                                </Th_title>
                            </tr>
                        )}
                        {progressStatusValue.rejected === ContentStatus.REJECT.statusValue && (
                            <tr>
                                <Th_title title={"반려정보"} className="fieldset-td" colspan={3}>
                                    <div>{`반려자 : ${progressStatusValue.rejectUser.department ? `[${progressStatusValue.rejectUser.department.name}]` : ''} ${progressStatusValue.rejectUser.name}`}</div>
                                    <div className={"mt-2"}>{progressStatusValue.description}</div>
                                </Th_title>
                            </tr>
                        )}
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
            )}
        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent
                auth
                contentId={serviceApply.id}
                contentCategory={ContentCategory.SERVICE_APPLY}
            />
            <DetailFilePanel
                title="첨부"
                isEditing={false}
                tableInfo={{tableName: ContentCategory.SERVICE_APPLY, joinKey: serviceApply.id}}
            />
        </>
    );

    return (
        <>
            {Object.keys(serviceApply).length > 0 && (
                <ContentDetailInfoShell
                    title={serviceApply.title || "서비스 신청"}
                    meta={serviceApply.serialNumber}
                    contentId={serviceApply.id}
                    contentCategory={ContentCategory.SERVICE_APPLY}
                    scrollMode="columns"
                    listUrl="/serviceRequest/serviceApply"
                    rollup={{cancel: {url: "/serviceRequest/serviceApply"}, data: serviceApply}}
                >
                    <ContentDetailThreeColLayout
                        primary={requestInfoPanel}
                        secondary={workflowPanels}
                        aside={asidePanel}
                    />
                </ContentDetailInfoShell>
            )}
        </>
    );
};

export default ServiceApplyInfo;
